import { useQuery } from '@tanstack/react-query';
import { hasAssistantPrivileges, hasOwnerPrivileges, isBookkeepingWriterRole } from '@packages/types';
import { queryKeys } from '@packages/api';
import { getAccount } from '@packages/api/endpoints/account.js';
export function deriveAccountState(account, userId, isLoading, isError) {
    const role = account?.members.find((m) => m.user.id === userId)?.role ?? null;
    const isOwner = hasOwnerPrivileges(role);
    const isOwnerOrAssistant = hasOwnerPrivileges(role) || hasAssistantPrivileges(role);
    const isBookkeepingWriter = isBookkeepingWriterRole(role);
    const canManageHumanTeam = hasOwnerPrivileges(role) || role === 'assistant';
    const administeredBy = account?.administeredBy ?? null;
    return {
        account,
        role,
        isOwner,
        isOwnerOrAssistant,
        isBookkeepingWriter,
        canManageHumanTeam,
        administeredBy,
        isLoading,
        isError,
    };
}
/**
 * Core account state hook - platform-agnostic.
 * Each platform wraps this in their own AccountProvider with createContext.
 */
export function useAccountState(accountId, userId) {
    const { data: account = null, isLoading, isError } = useQuery({
        queryKey: queryKeys.account(accountId || ''),
        queryFn: () => getAccount(accountId),
        enabled: !!accountId,
    });
    return deriveAccountState(account, userId, isLoading, isError);
}
